import http from './http-service'
import config from '../config/constant'

const internalVerifyFundTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'INTERNALACCTRANSFER',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.fundTransfer.crpFt, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const internalInitiateTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'FUNDTRANSFERCONFIRM',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.fundTransfer.crpFtConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const externalVerifyFundTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'EXTERNALACCTRANSFER',
      otp: '',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.fundTransfer.crpFt, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const externalInitiateTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'EXTERNALACCTRANSFERCONFIRM',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.fundTransfer.crpFtConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyOwnAccTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'OWNACCTRANSFER',
    }
    const response = await http.post(config.fundTransfer.crpFt, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmOwnAccTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'OWNACCTRANSFERCONFIRM',
    }
    const response = await http.post(config.fundTransfer.crpFtConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSwiftCurrencies = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.fundTransfer.getCurrencies, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyBulkTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'BULKTRANSFERVERIFY',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.fundTransfer.bulkft, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmBulkTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'BULKTRANSFERCONFIRM',
      module: 'FUNDTRANSFER',
    }
    const response = await http.post(config.fundTransfer.bulkftConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyIATTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'FUNDTRANSFER',
      bulkTransfer: 'false',
    }
    const response = await http.post(config.fundTransfer.crpFt, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmIATTransfer = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'FUNDTRANSFERCONFIRM',
    }
    const response = await http.post(config.fundTransfer.crpFtConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const onVerifyFileUpload = async (data) => {
  try {
    data.append('requestId', 'FILEUPLOADINITIATE')
    const response = await http.post(config.fileUpload.initVerify, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const onConfirmFileUpload = async (data) => {
  try {
    data.append('requestId', 'FILEUPLOADINITIATE')
    const response = await http.post(config.fileUpload.initConfirm, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export function showXlsxFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/xlsx' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.xlsx`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

const downloadSampleTemplate = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.userActions.downloadExcelTemplate, reqParams, {
      responseType: 'arraybuffer',
    })
    showXlsxFile(response.data, `Salary_Upload_${data.typeOfFile}${new Date().getTime()}`)
    return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}
const invoiceUpload = async (data) => {
  try {
    data.append('requestId', 'INVOICEUPLOAD')
    data.append('otp', '123')
    data.append('randomKey', '123')
    const response = await http.post(config.fundTransfer.invoiceUpload, data)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getFileProcessList = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'FILEUPLOADPROCESSLIST',
    }
    const response = await http.post(config.fileUpload.getFileProcessList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const downloadTemplate = async (data) => {
  try {
    const response = await http.post(config.fileUpload.downloadTemplate, data, {
      responseType: 'blob',
    })
    showXlsFile(response.data, `sample_file_upload_template`)
  } catch (err) {
    return Promise.reject(err)
  }
}

export function showXlsFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: 'application/xlsx' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.xls`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

const TransferService = {
  internalVerifyFundTransfer,
  internalInitiateTransfer,
  externalInitiateTransfer,
  externalVerifyFundTransfer,
  verifyOwnAccTransfer,
  confirmOwnAccTransfer,
  getSwiftCurrencies,
  verifyBulkTransfer,
  confirmBulkTransfer,
  verifyIATTransfer,
  confirmIATTransfer,
  onVerifyFileUpload,
  onConfirmFileUpload,
  downloadSampleTemplate,
  invoiceUpload,
  getFileProcessList,
  downloadTemplate,
}

export default TransferService
